export const isGainsightAvailable = () => typeof window !== 'undefined' && !!window.aptrinsic;

export const trackEvent = (eventName, properties) => {
    if (!isGainsightAvailable()) return;
    try {
        window.aptrinsic('track', eventName, properties);
    } catch (error) {
        console.error('Gainsight track failed:', eventName, error);
    }
};

// GTM loads PX async, so aptrinsic may be missing right after login.
export const whenGainsightReady = (fn, {attempts = 20, intervalMs = 500} = {}) => {
    let timer = null;
    const attempt = (remaining) => {
        if (isGainsightAvailable()) fn();
        else if (remaining > 1) timer = setTimeout(() => attempt(remaining - 1), intervalMs);
    };
    attempt(attempts);
    return () => clearTimeout(timer);
};

let cancelPendingIdentify = () => {};

export const identifyUser = (user, account) => {
    cancelPendingIdentify();
    cancelPendingIdentify = whenGainsightReady(() => {
        try {
            window.aptrinsic('identify', user, account);
        } catch (error) {
            console.error('Gainsight identify failed:', error);
        }
    });
};

// PX identity lives in a 1-year cookie; reset so a shared browser drops the last user.
export const resetIdentity = () => {
    cancelPendingIdentify();
    if (!isGainsightAvailable()) return;
    try {
        window.aptrinsic('reset');
    } catch (error) {
        console.error('Gainsight reset failed:', error);
    }
};
